import { createScheduleTask, parseNumber } from "@/utils/utils"
import { getIsOnline } from "@/api/auth"
import { setTenantId } from "@/plugins/env"

/**
 * 定时刷新Token
 */
const handleRefreshToken = ({ store }) => {
  const refreshTime = parseNumber(process.env.VUE_APP_REFRESH_TOKEN_TIME, 1000 * 60 * 5)
  const scheduleTask = createScheduleTask({
    callback: async () => {
      if (store.state.isOnline) {
        try {
          let { data: isOnline } = await getIsOnline()
          isOnline = !!isOnline
          store.commit("setIsOnline", isOnline)
        } catch (error) {
          console.log(error)
        }
      } else {
        scheduleTask.stop()
      }
    },
    interval: refreshTime,
    immediate: true
  })

  scheduleTask.start()
}
/**
 * 客户端初始化
 * @param {*} context
 */

export default function (context) {
  setTenantId(context)
  handleRefreshToken(context)
}
